<script>
import {slugify} from '@/helpers/strings';
import {reactive, ref} from 'vue';
import {useStore} from "@/helpers/store-effect";

export default {
  name: 'AssignSettings',
  template: '#assign-settings-template',
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const workflow = store.workflow;
    const variables = props.node.property('variables');
    const nameInput = ref(null);
    const valueInput = ref(null);

    const form = reactive({
      variable: {
        id: '',
        name: '',
        value: '',
      },
    });

    const addVariable = () => {
      form.variable.name = form.variable.name.trim();
      form.variable.id = slugify(form.variable.name, '_');
      if (!form.variable.id) {
        return;
      }
      variables[form.variable.id] = {...form.variable};

      form.variable.id = '';
      form.variable.name = '';
      form.variable.value = '';

      nameInput.value.focus();
    };

    const removeVariable = (variable) => {
      delete variables[variable];
    };

    return {
      nameInput,
      valueInput,
      workflow,
      variables,
      form,
      removeVariable,
      addVariable,
    };
  },
};
</script>
